import { render, staticRenderFns } from "./messageMaintain.vue?vue&type=template&id=614c39aa&scoped=true&"
import script from "./messageMaintain.vue?vue&type=script&lang=ts&"
export * from "./messageMaintain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614c39aa",
  null
  
)

export default component.exports